import { DocumentNode, gql } from '@apollo/client';
import { Grid, GridItem, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';
import { SpeakerCard } from '@/imports/ui/components/SpeakerCard';

import { SpeakersCard_SimpleEventFragment } from './graphql-types/SpeakersCard_SimpleEventFragment';

export const SpeakersCard: React.FC<{
  simpleEvent: SpeakersCard_SimpleEventFragment;
}> & { simpleEventFragment: DocumentNode } = ({ simpleEvent }) => {
  const visibleSpeakers =
    simpleEvent.speakers?.filter((speaker) => !speaker.isHidden) ?? null;

  if (!visibleSpeakers?.length) {
    return null;
  }

  return (
    <Card p="6">
      <Stack spacing="4">
        <Text textStyle="xlBodyStrong">Speakers</Text>

        <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap="4">
          {visibleSpeakers.map((speaker) => {
            return (
              <NextLink
                href={`/members/${speaker.user._id}`}
                key={speaker.user._id}
              >
                <GridItem>
                  <SpeakerCard user={speaker.user} />
                </GridItem>
              </NextLink>
            );
          })}
        </Grid>
      </Stack>
    </Card>
  );
};

SpeakersCard.simpleEventFragment = gql`
  fragment SpeakersCard_SimpleEventFragment on SimpleEventV2 {
    _id
    speakers {
      isHidden
      user {
        _id
        ...SpeakerCard_UserFragment
      }
    }
  }

  ${SpeakerCard.userFragment}
`;
